import React from 'react';

const Home = () => {

    return (
        <div>
           <h1>Welcome to Stranger's Things!</h1>
        </div>
    )
};

export default Home;